(function () {

    'use strict';

    angular.module('iplusjs.filter.highlightQuery', [
        'lodash'
    ])
    .filter('highlightQuery', HighlightQuery);

    HighlightQuery.$inject = [
        'lodash'
    ];
    function HighlightQuery(_) {
        var umlauteMap = {
                ä: 'ae',
                ö: 'oe',
                ü: 'ue',
                ß: 'ss'
            },
            umlauteMapInverted = {
                ae: 'ä',
                oe: 'ö',
                ue: 'ü',
                ss: 'ß'
            };

        return function (value, query) {
            var match,
                regexpQuery,
                regexpQueryUnified,
                regexpUmlaute = new RegExp('[' + _.keys(umlauteMap).join('') + ']', 'gi'),
                regexpUmlauteInverted = new RegExp(_.keys(umlauteMapInverted).join('|'), 'gi'),
                q;

            if (!query) {
                return value;
            }

            _.each([regexpUmlaute, regexpUmlauteInverted], function (r) {
                q = query.replace(r, function (char) {
                    return umlauteMap[_.toLower(char)] || umlauteMapInverted[_.toLower(char)] || char;
                });

                regexpQuery = new RegExp(_.escapeRegExp(query), 'i');
                regexpQueryUnified = new RegExp(_.escapeRegExp(q), 'i');

                if (regexpQueryUnified.test(value)) {
                    match = value.replace(regexpQueryUnified, '<strong>$&</strong>');
                    return false;
                } else if (regexpQuery.test(value)) {
                    match = value.replace(regexpQuery, '<strong>$&</strong>');
                    return false;
                }
            });

            return match;
        };
    }
})();
